import { Config } from "./types/global";
const config: Config = global.appConfig;
export const BASE_API_URL = config.apiRootUrl + config.apiBaseUrl;

export default config;
